module.exports = __webpack_public_path__ + "static/media/donney_fan.a5beb751.jpg";